const FE_List_Types = Object.freeze({
  Active: 1,
  MyRequests: 2,
  ReviewRequests: 3,
});
export default FE_List_Types;
